import React, { useEffect, useState } from "react";
import { OrderCheckOutApi } from "../../ApiCalls/OrderCheckout";
import { BASE_URL } from "../../constant/api";

const CheckoutProducts = ({fetchedOrder}) => {
  
  return (
    <div className="md:m-5 flex flex-col    gap-3">
      {fetchedOrder.Data?.map((item) => (
        <div
          key={item.id}
          className="w-full rounded border  justify-between p-4 flex  shadow"
        >
          <div className="flex items-center gap-3">
            <img
              //   src={cement}
              src={`${BASE_URL}${item.product_images}`}
              alt={item.name}
              className="h-20 w-20 rounded object-cover"
            />
            <div className="space-y-1 ">
              <h3 className="text-lg sm:text-base font-semibold">{item.name}</h3>
              <p className="pl-3 text-xs">Quantity: {item.quantity}</p>
              <p className="pl-3 text-xs">Price: {item.currency_symbol}{item.price} </p>

              <p className="pl-3 text-xs">
                Offer: {item.offer_percent}% off (Original: {item.currency_symbol}{item.actual_price}{" "}
                )
              </p>
              
            </div>
            
          </div>
          <div className="flex justify-center items-center">
            <p className=" text-sm text-end flex flex-1 font-semibold">
                Total : {item.currency_symbol}{item.price * item.quantity} 
              </p>
            </div>
        </div>
      ))}
    </div>
  );
};

export default CheckoutProducts;
